<template>
  <button
    type="button"
    class="kwadrat"
    :style="{ backgroundColor: currentColor.backgroundColor }"
    :aria-label="`Kolor dla cyfry ${colorNo}. Kliknij, aby wylosować kolejny.`"
    @click="randomColor"
  ></button>
</template>

<script>
import { COLORS } from '../data/colors';

export default {
  data() {
    return {
      colorNo: 9,
    };
  },
  emits: ['number1000-value'],
  computed: {
    currentColor() {
      return COLORS[this.colorNo];
    },
  },
  methods: {
    randomColor() {
      this.colorNo = Math.floor(Math.random() * 10);
      this.$emit('number1000-value', this.colorNo);
    },
  },
  mounted() {
    this.$emit('number1000-value', this.colorNo);
  },
};
</script>

<style scoped>
.kwadrat {
  transition: background-color 0.3s;
}
</style>
